import { IconPropsType } from '..';

export const PUBGIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M100 34.05V27.7417H97.1583V17.0167H3.78333V27.7417H0V34.05H3.625C3.85833 35.4167 3.95 60.625 3.73333 65.95H0V72.2583H3.78333V82.9833H97.1583V72.2583H100V65.95H97.325C97.0833 64.575 97 39.4083 97.2167 34.05H100ZM90.1667 76.3083H10.75V23.6917H90.0667C90.3 25 90.4 70.8333 90.1667 76.3083Z"
      fill="#8388A3"
    />
    <path
      d="M40.6419 65.9167H43.8085V28.3334C44.9502 28.3334 46.0419 28.2751 47.1419 28.3334C48.2419 28.3917 49.2252 27.9417 50.1585 28.6751V70.6334H34.4585V28.4084H40.2919L40.6669 28.7917L40.6419 65.9167Z"
      fill="#8388A3"
    />
    <path
      d="M66.8417 47.1417V28.4084H54.0584L53.575 28.9V46.475L52.4334 46.6V51.8584L53.6584 51.9334V70.6334H66.8V49.3167H65V47.1417H66.8417ZM61.7584 65.9H59.0167V52.6584L59.4167 52.2584H61.7584V65.9ZM61.8084 45.8334H59.0917C59.0713 45.8175 59.0543 45.7977 59.0417 45.775C59.013 45.733 58.9957 45.6842 58.9917 45.6334V34.1H61.8084V45.8334Z"
      fill="#8388A3"
    />
    <path
      d="M84.8085 70.65H71.3418V28.45H84.8085V38.3917H80.4668V34.1084H76.3668V65.8917H79.7002C79.9085 64.6917 79.9668 55.175 79.7918 51.675L78.6502 51.325V45.925H84.8502L84.8085 70.65Z"
      fill="#8388A3"
    />
    <path
      d="M16.9752 28.4V47.8H15.5085V53.3334L15.9752 53.8084H17.0335C17.0335 58.275 17.0335 66.0167 17.0335 70.425C17.0376 70.4707 17.055 70.5142 17.0835 70.55L17.1335 70.6084H22.4169V52.5H30.8335V28.4H16.9752ZM25.5002 47.7667H22.4502V34.1C22.8919 34.1 23.3919 34.0584 23.9002 34.05H25.5002V47.7667Z"
      fill="#8388A3"
    />
    <path
      d="M84.8085 70.65H71.3418V28.45H84.8085V38.3917H80.4668V34.1083H76.3668V65.8917H79.7001C79.9085 64.6917 79.9668 55.175 79.7918 51.675L78.6501 51.325V45.925H84.8501L84.8085 70.65Z"
      fill="#8388A3"
    />
  </svg>
);
